import loadScript from '../util/loader';

const selectors = {
  slideshow: '[data-product-slideshow]',
  singeImage: '[data-product-image]',
  zoomButton: '[data-zoom-button]',
  zoomWrapper: '[data-zoom-wrapper]',
  mediaId: 'data-media-id',
};

export function productPhotoswipeZoom(container, json) {
  const loadedPromise = loadScript({url: window.theme.assets.photoswipe});
  const returnZoom = loadedPromise
    .then(() => {
      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

      const triggers = container.querySelectorAll(selectors.zoomButton);
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const el = container.querySelector(selectors.zoomWrapper);
          const dataId = event.target.closest(`[${selectors.mediaId}]`).getAttribute(selectors.mediaId).toString();
          const items = [];
          for (let i = 0; i < json.media.length; i++) {
            if (json.media[i].media_type === 'image') {
              items[items.length] = {
                src: json.media[i].src,
                w: json.media[i].width,
                h: json.media[i].height,
                id: json.media[i].id,
              };
            }
          }
          const findImage = (element) => element.id.toString() === dataId;
          const index = items.findIndex(findImage);
          const options = {
            index,
            showHideOpacity: true,
            showAnimationDuration: 150,
            hideAnimationDuration: 250,
            bgOpacity: 1,
            spacing: 0,
            allowPanToNext: false,
            maxSpreadZoom: 3,
            history: false,
            loop: true,
            pinchToClose: false,
            modal: false,
            closeOnScroll: false,
            closeOnVerticalDrag: true,
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
              if (isMouseClick) {
                return 1.67;
              } else {
                return item.initialZoomLevel < 0.7 ? 1 : 1.3;
              }
            },
            getThumbBoundsFn: function getThumbBoundsFn() {
              let imageLocation = container.querySelector(selectors.slideshow);
              if (!imageLocation) {
                imageLocation = container.querySelector(selectors.singeImage);
              }
              const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
              const rect = imageLocation.getBoundingClientRect();
              return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            },
          };
          el.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
          // Initializes and opens PhotoSwipe
          const gallery = new PhotoSwipe(el, PhotoSwipeUI, items, options);
          gallery.init();
          gallery.listen('close', function () {
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
          });
        });
      });
    })
    .catch((e) => console.error(e));
  return returnZoom;
}
